import React from 'react'
import Title from './Title'
import { graphql, useStaticQuery } from "gatsby"
import "../css/skills.css"

export default function Skills() {
  const data = useStaticQuery(query)
  const { allStrapiSkills : { nodes : skills },} = data
  const { category} = skills
  console.log(category)

    return <section className="section bg-grey">
    <Title title="Skills" />
    {
      skills.map((skill)=>{
        return <div className="skills" key={skill.id}>
          <h4>{skill.category}</h4>
          <div className="icons-container">
          {
            skill.element.map((elm)=>{

              return <div className="skill-anim" key={elm.id}>
                        <img src={elm.image.publicURL} alt = "skill image" />
                        <span>{elm.name}</span>
                      </div>
                    
            })
          }
          </div>
        </div>
       
      })
    }
  </section>

}

export const query = graphql`
  {
    allStrapiSkills {
      nodes {
        category
        id
        element {
          id
          name
          image {
            extension
            publicURL
          }
        }
      }
    }
  }
`
